<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择舞蹈风格"
    @change="handleChange"
    :style="width ? `width: ${width}` : ''"
  >
    <el-option
      v-for="v in list"
      :key="v.id"
      :label="v.style_name"
      :value="v.id"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-style';

export default {
  props: {
    value: [Number, String],
    width: String,
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ is_only_name: 1 });
      if (!isError) this.list = data;
    },
    handleChange(valueBackup) {
      const style = this.list.find(v => v.id === valueBackup);
      this.$emit('change', style.style_name);
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.getList();
  },
};
</script>
